/** Disparado tras asignar o revocar archivos/carpetas en Bóveda Digital. */
export const VAULT_FILE_ASSIGNMENTS_CHANGED_EVENT = 'vault-file-assignments-changed';

export function notifyVaultFileAssignmentsChanged(): void {
  if (typeof globalThis.window === 'undefined') {
    return;
  }
  globalThis.window.dispatchEvent(new CustomEvent(VAULT_FILE_ASSIGNMENTS_CHANGED_EVENT));
}
